var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 416,
    viewBox: "0 0 1600 416",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_171_3648)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 416,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip1_171_3648)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: -161,
    y1: 320.5,
    x2: 1759,
    y2: 320.5,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -161,
    y1: 352.5,
    x2: 1759,
    y2: 352.5,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -161,
    y1: 384.5,
    x2: 1759,
    y2: 384.5,
    stroke: "#4274C9"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: -0.499481,
    y1: 320,
    x2: -0.499565,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.5006,
    y1: 320,
    x2: 31.5005,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.5007,
    y1: 320,
    x2: 63.5006,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.5008,
    y1: 320,
    x2: 95.5007,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.501,
    y1: 320,
    x2: 127.501,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.501,
    y1: 320,
    x2: 159.501,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 191.501,
    y1: 320,
    x2: 191.501,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.501,
    y1: 320,
    x2: 223.501,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.501,
    y1: 320,
    x2: 255.501,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.501,
    y1: 320,
    x2: 287.501,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 319.501,
    y1: 320,
    x2: 319.501,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.501,
    y1: 320,
    x2: 351.501,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.502,
    y1: 320,
    x2: 383.501,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.502,
    y1: 320,
    x2: 415.501,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.502,
    y1: 320,
    x2: 447.502,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 479.502,
    y1: 320,
    x2: 479.502,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 511.502,
    y1: 320,
    x2: 511.502,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 543.502,
    y1: 320,
    x2: 543.502,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 575.502,
    y1: 320,
    x2: 575.502,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 607.502,
    y1: 320,
    x2: 607.502,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 639.502,
    y1: 320,
    x2: 639.502,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 671.502,
    y1: 320,
    x2: 671.502,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 703.502,
    y1: 320,
    x2: 703.502,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 735.502,
    y1: 320,
    x2: 735.502,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 767.502,
    y1: 320,
    x2: 767.502,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 799.502,
    y1: 320,
    x2: 799.502,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 831.502,
    y1: 320,
    x2: 831.502,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 863.503,
    y1: 320,
    x2: 863.503,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 895.503,
    y1: 320,
    x2: 895.503,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 927.503,
    y1: 320,
    x2: 927.503,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 959.503,
    y1: 320,
    x2: 959.503,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 991.503,
    y1: 320,
    x2: 991.503,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1023.5,
    y1: 320,
    x2: 1023.5,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1055.5,
    y1: 320,
    x2: 1055.5,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1087.5,
    y1: 320,
    x2: 1087.5,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1119.5,
    y1: 320,
    x2: 1119.5,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1151.5,
    y1: 320,
    x2: 1151.5,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1183.5,
    y1: 320,
    x2: 1183.5,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1215.5,
    y1: 320,
    x2: 1215.5,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1247.5,
    y1: 320,
    x2: 1247.5,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1279.5,
    y1: 320,
    x2: 1279.5,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1311.5,
    y1: 320,
    x2: 1311.5,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1343.5,
    y1: 320,
    x2: 1343.5,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1375.5,
    y1: 320,
    x2: 1375.5,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1407.5,
    y1: 320,
    x2: 1407.5,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1439.5,
    y1: 320,
    x2: 1439.5,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1471.5,
    y1: 320,
    x2: 1471.5,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1503.5,
    y1: 320,
    x2: 1503.5,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1535.51,
    y1: 320,
    x2: 1535.51,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1567.51,
    y1: 320,
    x2: 1567.51,
    y2: 2240,
    stroke: "#4274C9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1599.51,
    y1: 320,
    x2: 1599.51,
    y2: 2240,
    stroke: "#4274C9"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_171_3648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 416,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_171_3648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1921,
    height: 1921,
    fill: "white",
    transform: "translate(-161 320)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBg);
export default __webpack_public_path__ + "static/media/HeaderBg.ef1633e10a4a521cab6d890b86dc6054.svg";
export { ForwardRef as ReactComponent };